import { Component, Inject, Input, OnDestroy, OnInit, Renderer2, ViewEncapsulation, DOCUMENT } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import { StateService } from 'src/app/common/services/state.service'

@Component({
    selector: 'app-offline-overlay',
    templateUrl: './offline-overlay.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./offline-overlay.component.scss'],
    imports: []
})
export class OfflineOverlayComponent implements OnInit, OnDestroy {
  @Input() offlinePageData: any
  @Input() receiptNumber: any
  overlayInstructionBlock = false
  overlayOfflineContent = true
  instructionData: any
  paymentInstructions: any
  constructor (
    private stateService: StateService,
    private readonly renderer: Renderer2,
    private sanitizer: DomSanitizer,
    @Inject(DOCUMENT) readonly document: any
  ) { }

  ngOnInit () {
    this.overlayInstructionBlock = false
    this.overlayOfflineContent = true
    this.renderer.addClass(this.document.body, 'noScroll')
  }
  openOverlay (offlineData: any) {
    this.instructionData = offlineData
    this.paymentInstructions = this.sanitizer.bypassSecurityTrustHtml(this.instructionData?.instructions)
    if (document.getElementById('overlayBlock')?.classList.contains('offline-payment-options-overlay')) {
      document.getElementById('overlayBlock')?.classList.remove('offline-payment-options-overlay')
    }
    this.overlayInstructionBlock = true
    this.overlayOfflineContent = false
  }
  closeOverlay () {
    this.overlayOfflineContent = false
    this.stateService.closePopup.emit(false)
  }

  backToPopup () {
    this.overlayInstructionBlock = false
    this.overlayOfflineContent = true
    document.getElementById('overlayBlock')?.classList.add('offline-payment-options-overlay')
  }

  copyToClipboard (text: string) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text)
      const element = document.getElementById('toastNo')
      if (element) {
        this.renderer.addClass(element, 'toast--copied')
        setTimeout(() => this.renderer.removeClass(element, 'toast--copied'), 2000)
      }
      }
    }
    ngOnDestroy (): void {
      this.renderer.removeClass(this.document.body, 'noScroll')
    }
}
